import { EllipsisText } from 'canoe';
import { useFormikContext } from 'formik';
import React from 'react';

import { ContentPlacement } from '@candu-ai/placement/types';
import {
  CompletedStepSettings,
  EditLinkButton,
  StepTitle,
} from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { getPlacementUrlText } from 'craft/containers/Toolbox/tabs/Placements/utils';

interface Props {
  active: boolean;
  onEdit: VoidFunction;
}

export const StepOne = ({ onEdit }: Props) => {
  const { values } = useFormikContext<ContentPlacement>();

  const placementUrl = getPlacementUrlText(values);

  return (
    <div>
      <StepTitle size="short">1. Where will the Overlay go?</StepTitle>

      <CompletedStepSettings>
        <EllipsisText content={placementUrl}>
          <span dir="rtl">
            <bdi>
              <strong>{placementUrl}</strong>
            </bdi>
          </span>
        </EllipsisText>
        <EditLinkButton
          appearance="text"
          inline
          size="small"
          variant="white"
          fontWeight="xbold"
          onClick={onEdit}
        >
          edit
        </EditLinkButton>
      </CompletedStepSettings>
    </div>
  );
};
